import { instance2 } from './base';

export const getConf = (name) => {
    const config = {};
    if (name) {
        config.params = { name };
    }

    return instance2
        .get('/api/v1/configuration', config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error;
        });
};

export const getTenant = (endpoint) =>
    instance2
        .get('/api/v1/instances/endpoint', {
            params: {
                endpoint: endpoint,
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error;
        });

export const isConfigurationCompleted = () =>
    instance2
        .get('/api/v1/configuration/is-completed')
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error;
        });
